import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme, css } from 'styled-components';

import { trackEvent } from '../Analytics';

import logo from '../../images/logo-allegiant-blue.svg';

const NAV_SMALL = 50;
export const NAV_LARGE = 70;

/* Width values provided to avoid clipping on IE 11 */
const StyledLogo = styled.img`
  display: block;
  height: ${NAV_SMALL}px;
  width: 82px;
  padding: ${props => props.theme.spacing(2)} 0;
  transition: height 0.2s ease-in-out;

  ${props => props.theme.query.lg} {
    ${props =>
      !props.small &&
      css`
        height: ${NAV_LARGE}px;
        width: 137px;
      `};
  }
`;

StyledLogo.propTypes = {
  /** Forces the small logo variant to be rendered */
  small: PropTypes.bool,
};

StyledLogo.defaultProps = {
  small: false,
};

const Logo = ({ hasScrolled }) => (
  <a href="/" aria-label="Go to home page">
    <StyledLogo
      src={logo}
      alt=""
      small={hasScrolled}
      onClick={() =>
        trackEvent(
          'Site Click Tracking',
          'HO Logo',
          ' Allegiant Air - Cheap Flights, Air+Hotel Packages, Discounted Car Rentals'
        )
      }
    />
  </a>
);

Logo.propTypes = {
  hasScrolled: PropTypes.bool,
};

export default withTheme(Logo);
